module.exports = __webpack_public_path__ + "img/arrow_and_edge.76c7d44a.svg";